import React from 'react';
import { Button } from '@/components/ui/button';
import clsx from 'clsx';
import { Typography } from '@/components/common';
import { ChevronDown } from 'lucide-react';

interface Props {
	open: boolean;
	value?: string;
	label?: string;
	placeholder?: string;
}
export const ButtonDropdownFilter: React.FC<Props> = ({
	open,
	value,
	label,
}) => {
	return (
		<Button
			variant="outline"
			aria-expanded={open}
			className={clsx('relative gap-2 min-w-max bg-white')}
		>
			<Typography
				type="semibold-14"
				className={clsx(
					'!line-clamp-1 text-ellipsis overflow-hidden whitespace-normal text-left opacity-60'
				)}
			>
				{label}
			</Typography>
			<ChevronDown
				className={`mt-0.5 h-5 w-5 shrink-0 text-[#0D0616] ${
					open && 'rotate-180'
				}`}
			/>
			{value && (
				<span className="w-[10px] h-[10px] bg-main-blue rounded-full absolute -top-1 -right-1 z-20" />
			)}
		</Button>
	);
};
